import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, Award, Users, Clock, Briefcase } from 'lucide-react';
import { companyInfo } from '../mockData';

const credentials = [
  { icon: Briefcase, text: "5+ Tahun Pengalaman" },
  { icon: Users, text: "1,247+ Pelanggan" },
  { icon: Award, text: "Pakar Penjawat Awam" },
  { icon: Clock, text: "Respons 24 Jam" }
];

const ConsultantProfile = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      'Assalamualaikum Encik Aiman, saya berminat untuk konsultasi dan ingin mendapatkan maklumat lanjut.'
    );
    window.open(`https://wa.me/${companyInfo.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-br from-emerald-50 to-amber-50/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-emerald-900 mb-3">
              Kenali Consultant Anda
            </h2>
            <p className="text-emerald-700 text-sm sm:text-base">
              Anda bukan hubungi syarikat - anda hubungi orang yang prihatin
            </p>
          </div>

          {/* Profile Card */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-emerald-100">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left: Photo/Avatar */}
              <div className="lg:col-span-2 bg-gradient-to-br from-emerald-800 to-emerald-950 p-8 sm:p-12 flex flex-col items-center justify-center text-center relative">
                {/* Decorative dots */}
                <div className="absolute top-0 left-0 w-full h-full opacity-10">
                  <div className="absolute top-10 left-10 w-32 h-32 bg-amber-400 rounded-full blur-3xl"></div>
                  <div className="absolute bottom-10 right-10 w-32 h-32 bg-amber-500 rounded-full blur-3xl"></div>
                </div>
                
                {/* Real Photo */}
                <div className="relative z-10">
                  <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full overflow-hidden shadow-2xl mb-6 border-4 border-amber-400">
                    <img
                      src="https://customer-assets.emergentagent.com/job_susun-kewangan/artifacts/kr8dgck5_IMG_0072.jpeg"
                      alt="Muhd Aiman - Financial Consultant"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                    Muhd Aiman
                  </h3>
                  <p className="text-amber-300 font-semibold mb-4">
                    Financial Consultant
                  </p>
                  <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
                    <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                    <span className="text-white text-sm">Available Online</span>
                  </div>
                </div>
              </div>

              {/* Right: Content */}
              <div className="lg:col-span-3 p-6 sm:p-10">
                {/* Tagline */}
                <div className="mb-6">
                  <span className="inline-block px-3 py-1 bg-amber-100 text-amber-800 text-xs font-bold rounded-full border border-amber-200 mb-3">
                    👋 ASSALAMUALAIKUM
                  </span>
                  <h3 className="text-xl sm:text-2xl font-bold text-emerald-900 mb-3">
                    "Saya faham cabaran kewangan penjawat awam."
                  </h3>
                </div>

                {/* Bio */}
                <div className="space-y-4 mb-6 text-emerald-800 text-sm sm:text-base leading-relaxed">
                  <p>
                    Sepanjang <strong>5+ tahun</strong> sebagai financial consultant di Sarawak, saya telah membantu lebih <strong>1,247 penjawat awam, polis, tentera dan guru</strong> menyusun semula komitmen kewangan mereka.
                  </p>
                  <p>
                    Misi saya: <strong className="text-emerald-900">Bantu anda lega kewangan tanpa stress</strong>. Tiada hard-selling, tiada pressure. Hanya konsultasi yang jujur dan pilihan yang sesuai untuk anda.
                  </p>
                </div>

                {/* Credentials Grid */}
                <div className="grid grid-cols-2 gap-3 mb-6">
                  {credentials.map((cred, index) => {
                    const IconComponent = cred.icon;
                    return (
                      <div
                        key={index}
                        className="flex items-center gap-2 p-3 bg-emerald-50 rounded-lg border border-emerald-100"
                      >
                        <IconComponent className="h-5 w-5 text-emerald-700 flex-shrink-0" />
                        <span className="text-emerald-900 text-xs sm:text-sm font-semibold">
                          {cred.text}
                        </span>
                      </div>
                    );
                  })}
                </div>

                {/* CTA Button */}
                <Button
                  onClick={handleWhatsApp}
                  size="lg"
                  data-testid="consultant-whatsapp-btn"
                  className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white font-bold text-base px-6 py-6 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
                >
                  <MessageCircle className="mr-2 h-5 w-5" />
                  CHAT TERUS DENGAN AIMAN
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultantProfile;
